<template>
  <div :class="classes">
    <slot />
  </div>
</template>

<script>
export default {
  computed: {
    classes() {
      return [
        'ba-section',
      ];
    },
  },
};
</script>
